import type { DateRange } from '@cobliteam/common-types';
import type * as Actions from './actions';
import { ReportsActionTypes as Types } from './reportsActionTypes';

export const downloadIncidentsReportRequest = (period: DateRange): Actions.DownloadIncidentsReportRequest => ({
  type: Types.DOWNLOAD_INCIDENTS_REPORT_REQUEST,
  payload: period,
});

export const downloadIncidentsReportEnd = (): Actions.DownloadIncidentsReportEnd => ({
  type: Types.DOWNLOAD_INCIDENTS_REPORT_END,
});
